import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import { Input } from '../../../../../Common';

import './index.scss';

const MutateTasksListInput = ({ name, ...props }) => {
  const [field, fieldMeta] = useField(name);

  return (
    <Input
      {...props}
      {...field}
      className={classNames(
        'mutate-tasks-list-input',
        { 'mutate-tasks-list-input-error': fieldMeta.error },
        // eslint-disable-next-line react/destructuring-assignment
        props.className,
      )}
      type="text"
    />
  );
};

export default MutateTasksListInput;
